import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

const PALETTE = ["#1E2A38", "#8B1E23", "#B38A1F", "#2F5D50", "#5B4B8A", "#7A4E2D"];

function initials(name, email) {
  const source = (name || email || "?").trim();
  const parts = source.split(/[\s@._-]+/).filter(Boolean);
  return ((parts[0]?.[0] || "?") + (parts.length > 1 ? parts[1][0] : "")).toUpperCase();
}

function colorFor(key) {
  let h = 0;
  for (const ch of key || "") h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export function UserAvatar({ name, email, picture, className, testId }) {
  return (
    <Avatar className={cn("h-8 w-8", className)} data-testid={testId}>
      {picture && <AvatarImage src={picture} alt={name || email} referrerPolicy="no-referrer" />}
      <AvatarFallback className="text-white text-xs font-semibold" style={{ backgroundColor: colorFor(email || name) }}>
        {initials(name, email)}
      </AvatarFallback>
    </Avatar>
  );
}
